<template>
 <div>
        <div class="card-header col-md-12">
            <div class="row">
                <span class="col-lg-8">My Conditions</span>
                <a href="/my-health/conditions/add" class="card-action btn-link float-right col-lg-4" title="Redirect to Conditions Editing Page">
                    Edit
                    <i class="fas fa-pencil-alt"></i>
                </a>
            </div>
        </div>
        <div class="card-body gray-bg">
             <div class="row justify-content-center ">
                 <div class="col-md-12">

                     <ul class="list-group mb-3" v-if="cons.length>0">
                         <li :class="(c.prescriptions.length>0?'border-bottom-0 ':'')+'list-group-item border-top-0 border-right-0 border-left-0 ml-0 mr-0'" v-for="(c, key) in cons" v-if="view_more || key < 4">
                             <div class="row">
                                 <div class="col-md-8 sb-list-fitem-regular">
                                     {{c.condition_data?c.condition_data.cdd_name:c.cnd_srname}}
                                 </div>
                                 <div class="col-md-4 text-right sb-list-sitem">
                                     <a href="#" class="text-danger" @click.prevent="deleteConById(c)">
                                         Remove
                                     </a>
                                 </div>
                             </div>
                             <ul class="list-group">
                                 <li class="list-group-item border-top-0 border-left-0 border-right-0 pt-1 pb-1 sb-list-thitem-regular pl-3" v-for="p in c.prescriptions">
                                     <div class="shifted"> {{p.prescription_data?p.prescription_data.prd_name:p.pre_srname}} ({{p.pre_dosage}} {{p.dosage.dos_type}})</div>
                                 </li>
                             </ul>
                         </li>
                     </ul>


                     <div v-if="cons.length>4" class="text-right mb-3 mr-3">
                         <a href="#" @click.prevent="view_more=!view_more" v-if="view_more">View Less</a>
                         <a href="#" @click.prevent="view_more=!view_more" v-else>View More</a>
                     </div>
                     <div class="col-md-12 mb-2 text-center">
                         <a href="/my-health/conditions/add" class="btn btn-primary" title="Redirect to Conditions Adding Page">Add New Condition</a>
                     </div>
                     <!-- Modal -->
                     <div v-if="showModal">
                         <transition name="modal">
                             <div class="modal-mask">
                                 <div class="modal-wrapper">
                                     <div class="modal-dialog" role="document">
                                         <div class="modal-content">
                                             <div class="modal-header">
                                                 <h5 class="modal-title"><span v-if="update">Edit </span><span v-else>Add </span>Condition</h5>
                                                 <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                     <span aria-hidden="true" @click="showModal = false">&times;</span>
                                                 </button>
                                             </div>
                                             <div class="modal-body" id="con-form">
                                                 <multiselect
                                                         v-model="con.cnd_cddid"
                                                         track-by="cdd_id"
                                                         label="cdd_name"
                                                         placeholder="Type to search condition"
                                                         :searchable="true"
                                                         :allow-empty="false"
                                                         :options="searchconditions"
                                                         :limit="3"
                                                         @search-change="asyncFindCondition"
                                                 >
                                                     <template slot="noOptions">Please type to search</template>
                                                 </multiselect>
                                                 <div class="form-group">
                                                     <input type="hidden" name="cnd_cddid">
                                                 </div>
                                                 <div class="form-group">
                                                     <input type="text" placeholder="Note" v-model="con.cnd_name" id="cnd_name" name="cnd_name" class="required form-control"/>
                                                 </div>
                                                 <multiselect
                                                         v-if="!fromRx"
                                                         v-model="con.prescriptions"
                                                         track-by="pre_id"
                                                         :custom-label="customLabel"
                                                         placeholder="Type to search prescription"
                                                         :searchable="true"
                                                         :multiple="true"
                                                         :allow-empty="true"
                                                         :options="searchrxs"
                                                         :taggable="true"
                                                         @tag="addRx"
                                                         tag-placeholder="Add new prescription"
                                                         @search-change="asyncFindRx"
                                                 >
                                                     <template slot="noOptions">Please type to search</template>
                                                 </multiselect>
                                             </div>
                                             <div class="modal-footer">
                                                 <button type="button" class="btn btn-secondary" @click="showModal = false">Close</button>
                                                 <button v-if="update" type="button" class="btn btn-danger" @click="deleteCon">Delete</button>
                                                 <button v-if="!update" type="button" class="btn btn-primary" @click="saveCon">Add</button>
                                                 <button v-if="update" type="button" class="btn btn-primary" @click="updateCon">Update</button>
                                             </div>
                                         </div>
                                     </div>
                                 </div>
                             </div>
                         </transition>
                     </div>

                 </div>
             </div>
        </div>
 </div>
</template>

<script>
    export default {
        props:['conditions'],
        mounted() {
            this.listCon(true);
        },
        created: function() {
            bus.$on('listRX', this.updateRx)
            bus.$on('updateConditions', this.listCon)
            bus.$on('updateOldCondition', this.updateOldCondition)
            bus.$on('addCon',this.addConFromRx)
        },
        data(){
            return {
                route: '/api/conditions',
                update: false,
                showModal: false,
                fromRx: false,
                rx:'',
                searchconditions:[],
                searchrxs:[],
                con:{
                    id:'',
                    cnd_cddid:'',
                    cnd_name:'',
                    prescriptions:'',
                },
                cons:[],
                rxs:[],
                rx_name:'',
                view_more: false
            }
        },
        methods:{
            asyncFindRx(query){
                if(query==''){
                    this.searchrxs=[]
                }else{
                    this.searchrxs=this.rxs
                }

            },
            asyncFindCondition(query){
                if(query==''){
                    this.searchconditions=[]
                }else{
                    this.searchconditions=this.conditions
                }
            },
            addNewCon(name){
                this.conditions.push({'cdd_name':name,'cdd_id':0})
                this.con.cnd_cddid={'cdd_name':name,'cdd_id':0};
            },
            addRx(tag){
                this.showModal=false;
                bus.$emit('addRx', this.con);
            },
            addConFromRx(rx){
                this.rx=rx;
                this.showModal=true;
                this.update=false;
                this.fromRx=true;
                this.con={
                    id:'',
                    cnd_cddid:'',
                    cnd_name:'',
                    prescriptions:'',
                };
            },
            customLabel(data){
              return data.prescription_data.prd_name
            },
            updateRx(data){
                this.rxs=data
            },
            log(s){
                console.log(s)
            },
            addCon(){
                this.showModal=true;
                this.update=false
                this.con={
                    id:'',
                    cnd_cddid:'',
                    cnd_name:'',
                    prescriptions:''
                };
            },
            updateOldCondition(condition){
                this.showModal=true;
                this.update=false
                this.con=condition;
            },
            saveCon(){

                this.$http.post(this.route, this.con)
                    .then(function(response) {
                        this.listCon();
                        this.showModal=false;
                        bus.$emit('updatePrescriptions');
                        if(this.fromRx){
                            this.fromRx=false
                            var con=this.con
                            con.cnd_id=response.body
                            con.condition_data=this.con.cnd_cddid;
                            this.rx.conditions=[con]
                            bus.$emit('updateOldRx',this.rx);
                        }

                    }, (response) => {
                        this._handleErrors(response.data, '#con-form')
                    })
            },
            listCon(fromProp = false){
                if (fromProp) {
                    this.cons = this.conditions;
                    bus.$emit('listCon',this.cons);
                } else {
                    this.$http.get(this.route)
                        .then(function(response) {
                            this.cons=response.data;
                            bus.$emit('listCon',this.cons);
                        }, (response) => {
                            this._handleErrors(response.data, '#con-form')
                        })
                }
            },
            show(c){
                this.showModal=true;
                this.update=true
                this.con={
                    id:c.cnd_id,
                    cnd_cddid:{
                        cdd_id:c.cnd_cddid,
                        cdd_name:c.condition_data.cdd_name

                    },
                    cnd_name:c.cnd_name,
                    prescriptions:c.prescriptions
                };
            },
            updateCon(){
                this.$http.put(this.route, this.con)
                    .then(function(response) {
                        this.listCon();
                        this.showModal=false;
                        bus.$emit('updatePrescriptions');
                    }, (response) => {
                        this._handleErrors(response.data, '#con-form')
                    })
            },
            deleteConById(con){
                if (!confirm('Do you really want to delete this condition?'))
                    return

                this.$http.delete(this.route+'/'+con.cnd_id)
                    .then(function(response) {
                        this.listCon();
                        if(response.bodyText=="1"){
                            this.$notify({
                                type: 'success',
                                title: 'Success',
                                text: 'Condition was deleted!'
                            });
                        }else{
                            this.$notify({
                                type: 'error',
                                title: 'Success',
                                text: response.bodyText
                            });
                        }
                    }, (response) => {
                        this._handleErrors(response.data, '#con-form')
                    })
            },
            deleteCon(){
                this.$http.delete(this.route+'/'+this.con.cnd_id)
                    .then(function(response) {
                        this.listCon();
                        this.showModal=false;
                    }, (response) => {
                        this._handleErrors(response.data, '#con-form')
                    })
            },
            _handleErrors: function(items, selector)
            {
                $('.has-error').removeClass('has-error')
                $('.help-block').remove()

                for (var error in items['errors']) {
                    if (items['errors'].hasOwnProperty(error)) {
                        var text = error;
                        var parts = text.split('.');
                        var name = parts.pop();
                        var el = $(selector + ' [name="'+name+'"]')
                        el.closest('.form-group').addClass('has-error')
                        $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                    }
                }
            }
        }

    }
</script>
